import type { FC } from 'react';

import { DismissibleCallout } from 'mastodon/components/callout/dismissible';
import { siteNotice } from 'mastodon/initial_state';

import classes from './styles.module.scss';

/**
 * Server-wide notice configured by admins in
 * Administration → Server settings → Appearance.
 *
 * The dismissal is remembered per browser, keyed by a hash of the
 * notice text and variant, so editing the notice shows it again.
 */
export const SiteNoticeBanner: FC = () => {
  if (!siteNotice?.text) {
    return null;
  }

  return (
    <div className={classes.wrapper}>
      <DismissibleCallout
        id={`site_notice_${siteNotice.id}`}
        variant={siteNotice.variant}
        className={classes.callout}
      >
        <p className={classes.text}>{siteNotice.text}</p>
      </DismissibleCallout>
    </div>
  );
};
